import { Component, OnInit, AfterContentChecked, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { SpecialCircumstances } from '../models/special-circumstances';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { Store } from '@ngrx/store';
import { Action_ApplicationSectionSaved } from '../state/actions';
import { forkJoin, Observable } from 'rxjs';
import { ModalService } from 'src/app/shared/services/modal.service';
import { compareSpecialCircumstances } from '../shared/utils/ModelUtils';
import { slideInOut } from '../animations/slideInOut';
import { FormService } from 'src/app/shared/services/form.service';
import { Title } from '@angular/platform-browser';
import { LookupData, Tab_Title } from 'src/app/shared/models/lookup-data.model';
import { LookupService } from 'src/app/shared/services/lookup.service';
import { tap } from 'rxjs/operators';
import { MatSelectionList } from '@angular/material';

@Component({
  selector: 'online-app-special-circumstances',
  templateUrl: './special-circumstances.component.html',
  styleUrls: ['./special-circumstances.component.scss'],
  host: {
    class: 'application-section-component'
  },
  animations: [slideInOut]
})
export class SpecialCircumstancesComponent implements OnInit, AfterContentChecked {

  specialCircumstancesFormGroup: FormGroup;
  isFormSubmitted = false;
  isScrollDone = false;
  applicationId: number;

  hadCovid19Vaccination: boolean;
  covid19VaccinesTaken: string;
  covid19ErrorMsg = '';

  isDisabled: boolean;
  wasHospitalised: boolean;
  hasMedicalHistory: boolean;
  hadViolentBehaviour: boolean;
  wasSuspended: boolean;
  suspensionDueToViolenceToPerson: boolean;
  suspensionDueToIllegalDrugs: boolean;
  suspensionDueToWeaponPossession: boolean;
  suspensionDueToViolenceAtSchool: boolean;
  suspendedDueToOtherReason: boolean;
  involvedInOtherIncidentsOutsideSchool: boolean;
  suspensionReasonErrorMsg = '';

  initialSpecialCircumstanceDetails: SpecialCircumstances;


  schoolProgramType: string = '';
  accommodationWelfareId: number = 0;
  isCovid19VaccinationNeeded: boolean = false;
  deiApprovedCovid19Vaccines: LookupData[] = [];

  isSaveSuccessful = false;
  isSubmittedApplication = false;

  @ViewChild('') vaccines: MatSelectionList

  errorKeyFormFieldMapping = [
    { apiErrorKeyName: 'HadCovid19Vaccination', formFieldName: 'hadCovid19Vaccination', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'Covid19VaccinesTaken', formFieldName: 'covid19VaccinesTaken', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'IsDisabled', formFieldName: 'isDisabled', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'DisabledDescription', formFieldName: 'disabledDescription', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'WasHospitalised', formFieldName: 'wasHospitalised', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'HospitalisedDescription', formFieldName: 'hospitalisedDescription', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'HasMedicalHistory', formFieldName: 'hasMedicalHistory', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'MedicalHistoryDescription', formFieldName: 'medicalHistoryDescription', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'HadViolentBehaviour', formFieldName: 'hadViolentBehaviour', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'ViolentBehaviourDescription', formFieldName: 'violentBehaviourDescription', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'WasSuspended', formFieldName: 'wasSuspended', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SuspensionDueToViolenceToPerson', formFieldName: 'suspensionDueToViolenceToPerson', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SuspensionDueToIllegalDrugs', formFieldName: 'suspensionDueToIllegalDrugs', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SuspensionDueToWeaponPossession', formFieldName: 'suspensionDueToWeaponPossession', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SuspensionDueToViolenceAtSchool', formFieldName: 'suspensionDueToViolenceAtSchool', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'SuspendedDueToOtherReason', formFieldName: 'suspendedDueToOtherReason', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'OtherReasonForSuspension', formFieldName: 'otherReasonForSuspension', apiValidationErrorMsg: null },
    {
      apiErrorKeyName: 'InvolvedInOtherIncidentsOutsideSchool',
      formFieldName: 'involvedInOtherIncidentsOutsideSchool', apiValidationErrorMsg: null
    },
    { apiErrorKeyName: 'OtherIncidentsDescription', formFieldName: 'otherIncidentsDescription', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'ViolentBehaviourDescription', formFieldName: 'violentBehaviourDescription', apiValidationErrorMsg: null }
  ];

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private modalService: ModalService,
    private formService: FormService,
    private store: Store<any>,
    private applicationService: ApplicationService,
    private lookupService: LookupService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title) {

    this.activatedRoute.parent.params.subscribe(params => {
      this.applicationId = +params['id'];
    });


  }

  ngOnInit() {
    if(localStorage.getItem("isAgent") == "true"){
      this.titleService.setTitle(Tab_Title.Agent_SpecialCircumstances_Title);
    }else{
      this.titleService.setTitle(Tab_Title.SpecialCircumstances_Title);
    }
    this.specialCircumstancesFormGroup = this.formBuilder.group({
      hadCovid19Vaccination: '',
      covid19VaccinesTaken: '',

      isDisabled: false,
      disabledDescription: '',
      wasHospitalised: false,
      hospitalisedDescription: '',
      hasMedicalHistory: false,
      medicalHistoryDescription: '',
      hadViolentBehaviour: false,
      violentBehaviourDescription: '',
      wasSuspended: false,
      suspensionDueToViolenceToPerson: false,
      suspensionDueToIllegalDrugs: false,
      suspensionDueToWeaponPossession: false,
      suspensionDueToViolenceAtSchool: false,
      suspendedDueToOtherReason: false,
      otherReasonForSuspension: null,
      involvedInOtherIncidentsOutsideSchool: false,
      otherIncidentsDescription: ''
     

    });

    forkJoin([
      this.lookupService.getDeiApprovedCovid19Vaccines()
        .pipe(
          tap(x => this.deiApprovedCovid19Vaccines = x.Result)
        ),
      this.applicationService.getApplicationDetails(this.applicationId)
        .pipe(
          tap((response: SingleResultApiResponse) => {            
            this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';

            if (this.isSubmittedApplication) {
              this.specialCircumstancesFormGroup.disable();
            }
          })
        ),
      this.applicationService.isCovid19VaccinationNeeded(this.applicationId)
        .pipe(
          tap(x => this.isCovid19VaccinationNeeded = x)
        ),
      this.applicationService.getSpecialCircumstances(this.applicationId)
        .pipe(
          tap((response: SingleResultApiResponse) => {
            if (response.Result) {
              this.initialSpecialCircumstanceDetails = response.Result;
            }
          })
        ),
    ]).subscribe(() => {
      const covid19QuestionCtrl = this.specialCircumstancesFormGroup.get('hadCovid19Vaccination');
      const covid19VaccinesTakenCtrl = this.specialCircumstancesFormGroup.get('covid19VaccinesTaken');

      if (this.isCovid19VaccinationNeeded) {
        covid19QuestionCtrl.setValidators(Validators.required);
      } else {
        this.initialSpecialCircumstanceDetails.HadCovid19Vaccination = null;
        this.initialSpecialCircumstanceDetails.Covid19VaccinesTaken = '';
        
        covid19QuestionCtrl.clearValidators();
        covid19VaccinesTakenCtrl.clearValidators();
        covid19QuestionCtrl.setErrors(null);
        covid19VaccinesTakenCtrl.setErrors(null);
      }
      
      this.updateFormValuesFromSpecialCircumstances(this.initialSpecialCircumstanceDetails);

    }, err => {
      console.error(err);
    })    


  }

  updateCovid19VaccinationStatus(hadCovid19Vaccination: boolean) {
    if (this.isSubmittedApplication) {
      return;
    }

    this.hadCovid19Vaccination = hadCovid19Vaccination;

    this.specialCircumstancesFormGroup.patchValue({
      hadCovid19Vaccination: hadCovid19Vaccination,
      covid19VaccinesTaken: ''
    });

    this.specialCircumstancesFormGroup.updateValueAndValidity();
  }


  updateDisability(isDisabled: boolean) {

    if (this.isSubmittedApplication) {
      return;
    }

    this.isDisabled = isDisabled;

    this.specialCircumstancesFormGroup.patchValue({
      isDisabled: isDisabled
    });

    this.specialCircumstancesFormGroup.updateValueAndValidity();
  }

  updateHospitalization(wasHospitalised: boolean) {

    if (this.isSubmittedApplication) {
      return;
    }

    this.wasHospitalised = wasHospitalised;

    this.specialCircumstancesFormGroup.patchValue({
      wasHospitalised: wasHospitalised
    });

    this.specialCircumstancesFormGroup.updateValueAndValidity();
  }

  updateMedicalHistory(hasMedicalHistory: boolean) {

    if (this.isSubmittedApplication) {
      return;
    }

    this.hasMedicalHistory = hasMedicalHistory;

    this.specialCircumstancesFormGroup.patchValue({
      hasMedicalHistory: hasMedicalHistory
    });

    this.specialCircumstancesFormGroup.updateValueAndValidity();
  }

  updateSuspensionReason(event, reason: string) {

    if (this.isSubmittedApplication) {
      return;
    }

    switch (reason) {
      case 'suspensionDueToViolenceToPerson':

        this.suspensionDueToViolenceToPerson = event.checked;

        this.specialCircumstancesFormGroup.patchValue({
          suspensionDueToViolenceToPerson: this.suspensionDueToViolenceToPerson
        });

        this.specialCircumstancesFormGroup.updateValueAndValidity();

        break;
      case 'suspensionDueToIllegalDrugs':
        this.suspensionDueToIllegalDrugs = event.checked;

        this.specialCircumstancesFormGroup.patchValue({
          suspensionDueToIllegalDrugs: this.suspensionDueToIllegalDrugs
        });

        this.specialCircumstancesFormGroup.updateValueAndValidity();

        break;
      case 'suspensionDueToWeaponPossession':
        this.suspensionDueToWeaponPossession = event.checked;

        this.specialCircumstancesFormGroup.patchValue({
          suspensionDueToWeaponPossession: this.suspensionDueToWeaponPossession
        });

        this.specialCircumstancesFormGroup.updateValueAndValidity();

        break;

      case 'suspensionDueToViolenceAtSchool':
        this.suspensionDueToViolenceAtSchool = event.checked;

        this.specialCircumstancesFormGroup.patchValue({
          suspensionDueToViolenceAtSchool: this.suspensionDueToViolenceAtSchool
        });

        this.specialCircumstancesFormGroup.updateValueAndValidity();

        break;
      case 'suspendedDueToOtherReason':
        this.suspendedDueToOtherReason = event.checked;

        this.specialCircumstancesFormGroup.patchValue({
          suspendedDueToOtherReason: this.suspendedDueToOtherReason
        });

        this.specialCircumstancesFormGroup.updateValueAndValidity();

        break;
      default:

        this.suspensionDueToViolenceToPerson = false;
        this.suspensionDueToIllegalDrugs = false;
        this.suspensionDueToWeaponPossession = false;
        this.suspensionDueToViolenceAtSchool = false;

        this.specialCircumstancesFormGroup.patchValue({
          suspensionDueToViolenceToPerson: this.suspensionDueToViolenceToPerson,
          suspensionDueToIllegalDrugs: this.suspensionDueToIllegalDrugs,
          suspensionDueToWeaponPossession: this.suspensionDueToWeaponPossession,
          suspensionDueToViolenceAtSchool: this.suspensionDueToViolenceAtSchool
        });


        break;
    }

    this.getSuspensionError();
  }


  updateViolentBehaviour(hadViolentBehaviour: boolean) {

    if (this.isSubmittedApplication) {
      return;
    }

    this.hadViolentBehaviour = hadViolentBehaviour;

    this.specialCircumstancesFormGroup.patchValue({
      hadViolentBehaviour: hadViolentBehaviour
    });

    this.specialCircumstancesFormGroup.updateValueAndValidity();
  }

  updateSuspension(wasSuspended: boolean) {

    if (this.isSubmittedApplication) {
      return;
    }

    this.wasSuspended = wasSuspended;

    this.specialCircumstancesFormGroup.patchValue({
      wasSuspended: wasSuspended
    });

    if (!wasSuspended) {
      this.updateSuspensionReason(null, '');
    }

    this.specialCircumstancesFormGroup.updateValueAndValidity();
  }

  updateInvolvementInOutsideIncidents(involvedInOtherIncidentsOutsideSchool: boolean) {

    if (this.isSubmittedApplication) {
      return;
    }

    this.involvedInOtherIncidentsOutsideSchool = involvedInOtherIncidentsOutsideSchool;

    this.specialCircumstancesFormGroup.patchValue({
      involvedInOtherIncidentsOutsideSchool: involvedInOtherIncidentsOutsideSchool
    });

    this.specialCircumstancesFormGroup.updateValueAndValidity();
  }

  previous() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'visa-oshc']);
  }
  next() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'supporting-documents']);
  }

  getSuspensionError() {
    const suspensionDueToViolenceToPerson = this.specialCircumstancesFormGroup.get('suspensionDueToViolenceToPerson').value;
    const suspensionDueToIllegalDrugs = this.specialCircumstancesFormGroup.get('suspensionDueToIllegalDrugs').value;
    const suspensionDueToWeaponPossession = this.specialCircumstancesFormGroup.get('suspensionDueToWeaponPossession').value;
    const suspensionDueToViolenceAtSchool = this.specialCircumstancesFormGroup.get('suspensionDueToViolenceAtSchool').value;
    const suspendedDueToOtherReason = this.specialCircumstancesFormGroup.get('suspendedDueToOtherReason').value;
    const otherReasonForSuspension = this.specialCircumstancesFormGroup.get('otherReasonForSuspension').value || '';

    const wasSuspended = this.specialCircumstancesFormGroup.get('wasSuspended').value;
    const suspensionReasonAvailable = suspensionDueToViolenceToPerson ||
      suspensionDueToIllegalDrugs ||
      suspensionDueToWeaponPossession ||
      suspensionDueToViolenceAtSchool ||
      suspendedDueToOtherReason;

    if (wasSuspended && !suspensionReasonAvailable) {
      this.suspensionReasonErrorMsg = 'Please select at least one of the options above to proceed.';
    } else {
      this.suspensionReasonErrorMsg = '';
    }

  }

  getCovid19Error() {
    if (this.isCovid19VaccinationNeeded && this.specialCircumstancesFormGroup.get('hadCovid19Vaccination').value === true) {
      const covid19VaccinesTaken = this.specialCircumstancesFormGroup.get('covid19VaccinesTaken').value;

      if (!covid19VaccinesTaken || !covid19VaccinesTaken.length) {
        this.covid19ErrorMsg = 'Please select the vaccine(s) the student received'
      } else {
        this.covid19ErrorMsg = '';
      }      
    } else {
      this.covid19ErrorMsg = '';
    }
  }

  ngAfterContentChecked(): void {
    if (!this.isScrollDone) {
      this.isScrollDone = this.formService.scrollToFirstErrorField();
    }
  }

  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }

  updateFormValuesFromSpecialCircumstances(specialCircumstances: SpecialCircumstances): void {

    if (specialCircumstances == null) {
      specialCircumstances = new SpecialCircumstances();
    }

    if (this.isCovid19VaccinationNeeded && specialCircumstances.HadCovid19Vaccination == null) {
      specialCircumstances.HadCovid19Vaccination = true;
    }

    this.specialCircumstancesFormGroup.patchValue({
      hadCovid19Vaccination: specialCircumstances.HadCovid19Vaccination == null ? true : specialCircumstances.HadCovid19Vaccination,

      isDisabled: specialCircumstances.IsDisabled,
      disabledDescription: specialCircumstances.DisabledDescription,
      wasHospitalised: specialCircumstances.WasHospitalised,
      hospitalisedDescription: specialCircumstances.HospitalisedDescription,
      hasMedicalHistory: specialCircumstances.HasMedicalHistory,
      medicalHistoryDescription: specialCircumstances.MedicalHistoryDescription,
      hadViolentBehaviour: specialCircumstances.HadViolentBehaviour,
      violentBehaviourDescription: specialCircumstances.ViolentBehaviourDescription,
      wasSuspended: specialCircumstances.WasSuspended,
      suspensionDueToViolenceToPerson: specialCircumstances.SuspensionDueToViolenceToPerson,
      suspensionDueToIllegalDrugs: specialCircumstances.SuspensionDueToIllegalDrugs,
      suspensionDueToWeaponPossession: specialCircumstances.SuspensionDueToWeaponPossession,
      suspensionDueToViolenceAtSchool: specialCircumstances.SuspensionDueToViolenceAtSchool,
      suspendedDueToOtherReason: specialCircumstances.SuspendedDueToOtherReason,
      otherReasonForSuspension: specialCircumstances.OtherReasonForSuspension,
      involvedInOtherIncidentsOutsideSchool: specialCircumstances.InvolvedInOtherIncidentsOutsideSchool,
      otherIncidentsDescription: specialCircumstances.OtherIncidentsDescription
       
    });

    this.hadCovid19Vaccination = specialCircumstances.HadCovid19Vaccination;
    this.covid19VaccinesTaken = specialCircumstances.Covid19VaccinesTaken;

    // RENU:- To Avoid ExpressionChangedAfterItHasBeenCheckedError, Related to MatSelectList
    if (this.isCovid19VaccinationNeeded && this.hadCovid19Vaccination === true && !!specialCircumstances.Covid19VaccinesTaken) {
      setTimeout(() => {
        this.specialCircumstancesFormGroup.patchValue({
          covid19VaccinesTaken: (specialCircumstances.Covid19VaccinesTaken || '').split(','),
        });

        setTimeout(() => {
          this.specialCircumstancesFormGroup.updateValueAndValidity();
        }, 10);
      }, 10);
    }

    this.isDisabled = specialCircumstances.IsDisabled;
    this.wasHospitalised = specialCircumstances.WasHospitalised;
    this.hasMedicalHistory = specialCircumstances.HasMedicalHistory;
    this.hadViolentBehaviour = specialCircumstances.HadViolentBehaviour;
    this.wasSuspended = specialCircumstances.WasSuspended;
    this.suspensionDueToViolenceToPerson = specialCircumstances.SuspensionDueToViolenceToPerson;
    this.suspensionDueToIllegalDrugs = specialCircumstances.SuspensionDueToIllegalDrugs;
    this.suspensionDueToWeaponPossession = specialCircumstances.SuspensionDueToWeaponPossession;
    this.suspensionDueToViolenceAtSchool = specialCircumstances.SuspensionDueToViolenceAtSchool;
    this.suspendedDueToOtherReason = specialCircumstances.SuspendedDueToOtherReason;
    this.involvedInOtherIncidentsOutsideSchool = specialCircumstances.InvolvedInOtherIncidentsOutsideSchool;

    this.specialCircumstancesFormGroup.updateValueAndValidity();

  }

  getSpecialCircumstances(): SpecialCircumstances {

    const specialCircumstances = new SpecialCircumstances();

    specialCircumstances.HadCovid19Vaccination = this.isCovid19VaccinationNeeded ? this.specialCircumstancesFormGroup.get('hadCovid19Vaccination').value : null;
    specialCircumstances.Covid19VaccinesTaken = this.isCovid19VaccinationNeeded ? ((this.specialCircumstancesFormGroup.get('covid19VaccinesTaken').value || []) as string[]).join(',') : '';

    specialCircumstances.IsDisabled = this.specialCircumstancesFormGroup.get('isDisabled').value;
    specialCircumstances.DisabledDescription = this.specialCircumstancesFormGroup.get('disabledDescription').value;

    specialCircumstances.WasHospitalised = this.specialCircumstancesFormGroup.get('wasHospitalised').value;
    specialCircumstances.HospitalisedDescription = this.specialCircumstancesFormGroup.get('hospitalisedDescription').value;

    specialCircumstances.HasMedicalHistory = this.specialCircumstancesFormGroup.get('hasMedicalHistory').value;
    specialCircumstances.MedicalHistoryDescription = this.specialCircumstancesFormGroup.get('medicalHistoryDescription').value;

    specialCircumstances.HadViolentBehaviour = this.specialCircumstancesFormGroup.get('hadViolentBehaviour').value;
    specialCircumstances.ViolentBehaviourDescription = this.specialCircumstancesFormGroup.get('violentBehaviourDescription').value;

    specialCircumstances.WasSuspended = this.specialCircumstancesFormGroup.get('wasSuspended').value;
    specialCircumstances.SuspensionDueToViolenceToPerson = this.specialCircumstancesFormGroup.get('suspensionDueToViolenceToPerson').value;
    specialCircumstances.SuspensionDueToIllegalDrugs = this.specialCircumstancesFormGroup.get('suspensionDueToIllegalDrugs').value;
    specialCircumstances.SuspensionDueToWeaponPossession = this.specialCircumstancesFormGroup.get('suspensionDueToWeaponPossession').value;
    specialCircumstances.SuspensionDueToViolenceAtSchool = this.specialCircumstancesFormGroup.get('suspensionDueToViolenceAtSchool').value;
    specialCircumstances.SuspendedDueToOtherReason = this.specialCircumstancesFormGroup.get('suspendedDueToOtherReason').value;
    specialCircumstances.OtherReasonForSuspension = this.specialCircumstancesFormGroup.get('otherReasonForSuspension').value;

    specialCircumstances.InvolvedInOtherIncidentsOutsideSchool = this.specialCircumstancesFormGroup.get('involvedInOtherIncidentsOutsideSchool').value;
    specialCircumstances.OtherIncidentsDescription = this.specialCircumstancesFormGroup.get('otherIncidentsDescription').value;
    
    //phase 1 compatibility default values
    specialCircumstances.OtherDisabilitiesNotListed ="NA";
    specialCircumstances.AnyModificationsDoneAtHome = false;
    specialCircumstances.DetailsOfModificationAndStrategies ="NA";
    specialCircumstances.SpecificImpairmentsOrDisabilities = "NA";
  
    return specialCircumstances;

  }

  setApiValidationError(apiErrorKeyName: string, apiErrorMsg): void {
    //console.log(`In setApiValidationError.apiErrorKeyName: ${apiErrorKeyName}, apiErrorMsg:${apiErrorMsg}`);
    const errorField = this.errorKeyFormFieldMapping.find(errorKeyFormField => errorKeyFormField.apiErrorKeyName === apiErrorKeyName);

    if (errorField) {
      const { formFieldName } = errorField;
      this.specialCircumstancesFormGroup.get(formFieldName).setErrors({ apiValidationError: true });
      errorField.apiValidationErrorMsg = apiErrorMsg;
    }

  }

  getApiValidationErrorMsg(formFieldName: string): string {
    const errorField = this.errorKeyFormFieldMapping.find(errorKeyFormField => errorKeyFormField.formFieldName === formFieldName);
    return errorField.apiValidationErrorMsg ? errorField.apiValidationErrorMsg : '';
  }

  saveAndContinue() {
    this.isFormSubmitted = true;

    const specialCircumstances = this.getSpecialCircumstances();

    this.applicationService.updateSpecialCircumstances(this.applicationId, specialCircumstances)
      .subscribe((response: SingleResultApiResponse) => {
        this.dispatchSectionSaveAction();
        this.isSaveSuccessful = true;
        this.router.navigate(['/applications', this.applicationId, 'edit', 'supporting-documents']);
      }, (errorResponse: ErrorResponse) => {
        const { errors } = errorResponse;
        for (const error of errors) {
          this.setApiValidationError(error.Key, error.Value);
          // TODO
          // console.log(`Error in updating SpecialCircumstances details.${error.Key},${error.Value}`);
        }
        this.getSuspensionError();
        this.getCovid19Error();
        this.specialCircumstancesFormGroup.updateValueAndValidity();
        this.dispatchSectionSaveAction();
        this.initialSpecialCircumstanceDetails = this.getSpecialCircumstances();
        this.isScrollDone = false;
        this.formService.scrollToFirstErrorField();
      });

    return;
  }

  canDeactivate(): Observable<boolean> | boolean {

    if (this.isSaveSuccessful) {
      return true;
    }

    if (!this.isSpecialCirumstanceDetailsSame()) {
      this.modalService.showModal();
      return this.modalService.stayOnThePage;
    } else {
      this.modalService.hideModal();
      return true;
    }
  }


  isSpecialCirumstanceDetailsSame(): boolean {

    const currentSpecialCirumstanceDetails = this.getSpecialCircumstances();
    const initialSpecialCirumstanceDetails = this.initialSpecialCircumstanceDetails;

    const isSpecialCirumstanceDetailsSame =
      compareSpecialCircumstances(initialSpecialCirumstanceDetails, currentSpecialCirumstanceDetails);

    return isSpecialCirumstanceDetailsSame;
  }

  /* For accessibility, keyboard only design, use tab to show borders but showing no border by clicking on mouse */
  keyboardFocus(event): void {
    event.style.outline = "1px solid blue";
  }

  keyboardBlur(event): void {
    event.style.outline = "";
  }
}

